export default "__VITE_PUBLIC_ASSET__c42b3b6f__"